/**
 * ? does not seem to be used, to be deleted ?
 *
 * @param {*} selector 
 */
export const init = (selector) => {
    $( "input[type=checkbox]:visible" ).button().next().addClass('checkbox');
    selector = undefined==selector ? 'input' : selector;
    $(selector).click(function(){reset(this);});
    $(selector).focusin(function(){reset(this);});
};

/**
 * ? does not seem to be used, to be deleted ?
 * 
 * @param {*} selector 
 */
export const reset = (selector) => {
    $(selector).parent().removeClass('inputError');
    $(selector).parent().find('.textError').fadeOut();
    $(selector).closest('form').find('.formError').fadeOut();
};